import React, { FC } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useLandingPageContext } from 'context/LandingPageContext';
import extractTextBetweenBrackets from 'utils/extractTextBetweenBrackets';
import styles from './LPBtn.module.scss';

// Hacky way to add OP Plus to cart from Big Banner
// Function name is defined in contentful but no way to call it from React
// Instead we check reference value and use store operations to add OP Plus to cart
// eslint-disable-next-line no-script-url
export const ADD_OP_PLUS_REFERENCE = 'opPlusAddToCart';

export enum LPButtonSize {
  content = 'content',
  default = 'default',
  xsm = 'xsm',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xlg = 'xlg',
}

export const BUTTON_TYPE = {
  primary: {
    backgroundColor: '#27aaea',
    borderColor: '#27aaea',
    textColor: '#ffffff',
  },
  secondary: {
    backgroundColor: '#ffffff',
    borderColor: '#c7dce6',
    textColor: '#27aaea',
  },
} as const;

export interface LPButtonProps {
  referenceUrl: string;
  buttonColor: string;
  buttonBackgroundColor?: string;
  buttonBorderColor?: string;
  size?: LPButtonSize;
  className?: string;
  fontWeight?: 'normal' | 'bold';
}

const LPButton: FC<LPButtonProps> = ({
  referenceUrl,
  buttonColor: color,
  children,
  size = LPButtonSize.md,
  className,
  fontWeight = 'normal',
  buttonBackgroundColor: backgroundColor,
  buttonBorderColor: borderColor,
}) => {
  const { addOpPlus, theme } = useLandingPageContext();
  const { t } = useTranslation();
  const buttonStyle =
    theme === 'default'
      ? {
          color,
          backgroundColor,
          borderColor,
          fontWeight,
        }
      : {};

  const isOpPlusAddButton =
    referenceUrl.includes(ADD_OP_PLUS_REFERENCE) || referenceUrl.includes(ADD_OP_PLUS_REFERENCE);
  const redirectAfterPlusAdded = referenceUrl.includes(ADD_OP_PLUS_REFERENCE)
    ? extractTextBetweenBrackets(referenceUrl)
    : undefined;

  return isOpPlusAddButton ? (
    <div
      className={cn(className, styles[`theme-${theme}`], styles[`size-${size || LPButtonSize.lg}`])}
      style={buttonStyle}
      onClick={(e: any) => {
        e.preventDefault();
        e.stopPropagation();
        addOpPlus(true, redirectAfterPlusAdded || '');
      }}
    >
      {children}
    </div>
  ) : (
    <a
      href={referenceUrl}
      className={cn(styles[`theme-${theme}`], styles[`size-${size || LPButtonSize.lg}`])}
      style={buttonStyle}
    >
      {children}
    </a>
  );
};

export default LPButton;
